import '@babel/polyfill';
import Vue from 'vue';
import AutocompleteComponent from 'autocomplete-component';
import MapComponent from 'map-component/src';
import App from './App';

Vue.use(AutocompleteComponent);

Vue.config.productionTip = false;
Vue.config.warnHandler = function (msg, vm, trace) { };
// mocks components
// Install the plugin directly from src in development
Vue.use(MapComponent);


new Vue({
  render: function (h) {
    return h(App);
  }
}).$mount('#app');



// WEBPACK FOOTER //
// ./demo/main_demo.js